import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { loanEditSuccessResponse } from './loan-edit.schema';
var apiEndpoint = apiPaths.loan.edit;
function patchLoanEdit(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'PATCH', body: JSON.stringify(payload) },
        successSchema: loanEditSuccessResponse,
    });
}
export function usePatchLoanEdit() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: patchLoanEdit,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
